// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import { IChangePasswordRequest, useChangePassword, useGetPasswordSettings } from "../../../hooks";
import { Stack, Typography, Box, IconButton } from "@mui/material";
import Modal from "@mui/material/Modal";
import { PasswordControl } from "../../molecules";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useSetSnackBar } from "../../../store/Snackbar.state";
import { Button } from "../..";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";

import {
  changePasswordFormSchema,
  ChangePasswordFormSchemaFormValuesType,
  changePasswordInitialValues,
} from "./_formTypes";
import React, { useEffect, useState } from "react";

interface ChangePasswordModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ChangePasswordModal = ({
  isOpen,
  onClose,
}: ChangePasswordModalProps) => {
  const { data: passwordSettings, isLoading, error } = useGetPasswordSettings();
  const [minLength, setMinLength] = useState(null);
  const [maxLength, setMaxLength] = useState(null);

  useEffect(() => {
    if (passwordSettings?.data?.result) {
      const settings = passwordSettings.data.result;
      const minLengthValue = settings.find(item => item.key === 'REQUIREDMINLENGTH')?.value;
      const maxLengthValue = settings.find(item => item.key === 'REQUIREDMAXLENGTH')?.value;

      if (minLengthValue) setMinLength(minLengthValue);
      if (maxLengthValue) setMaxLength(maxLengthValue);
    }
  }, [passwordSettings]);
  const formSchema = minLength ? changePasswordFormSchema(minLength) : null;
  const { control, handleSubmit, watch } =
    useForm<ChangePasswordFormSchemaFormValuesType>({
      resolver: formSchema ? zodResolver(formSchema) : undefined,
      defaultValues: changePasswordInitialValues,
    });
  const setSnackbar = useSetSnackBar();
  const navigate = useNavigate();
  const { mutate: changePassword } = useChangePassword();



  const passwordValue = watch("password");
  const hasMinLength = passwordValue.length >= minLength;
  const hasUpperCase = /[A-Z]/.test(passwordValue);
  const hasLowerCase = /[a-z]/.test(passwordValue);
  const hasSpecialCharacter = /^[a-zA-Z0-9!@$?_\-\.]*[!@$?_\-\.]+[a-zA-Z0-9!@$?_\-\.]*$/.test(passwordValue);
  const hasNumber = /\d/.test(passwordValue);
  const listItemStyle = {
    transition: 'color 0.3s ease-in-out'
  };
  const checkPasswordAndSubmit = () => {
    if (!hasSpecialCharacter) {
      setSnackbar({
        severity: "error",
        description: "Şifrenizde sadece şu özel karakterleri kullanabilirsiniz: ! @ $ ? _ - .",
        isOpen: true,
      });
    } else {
      handleSubmit(onSubmit)();
    }
  };

  <Stack mt={5} justifyContent="center" alignItems="center">
    <Button
      onClick={checkPasswordAndSubmit}
      sx={{ width: 240, mb: 3 }}
      size="medium"
      variant="contained"
      text="Onayla"
    />
  </Stack>


  const onSubmit = (data: any) => {
    const request: IChangePasswordRequest = {
      oldPassword: data.oldPassword,
      password: data.password,
      confirmPassword: data.confirmPassword,
    };

    changePassword(request, {
      onSuccess: (data: any) => {
        if (data.isSuccess) {
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message,
          });
          navigate(0);
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }

      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });
  };

  return (
    <>
      <Modal
        sx={{ justifyContent: "center", alignItems: "center" }}
        open={isOpen}
        onClose={onClose}
      >
        <Stack
          sx={{
            width: "100vw",
            height: "100vh",
            justifyContent: "center",
            alignItems: "center",
            px: 1
          }}
        >
          <Stack
            borderRadius={2}
            p={8}
            sx={{ backgroundColor: "white", width: "100%", height: 630, maxWidth: "568px", p: { xs: 2, sm: 8 }, px: { xs: 2, sm: 5 }, position: "relative" }}
          >
            {/* <IconButton
              onClick={onClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                justifyContent: "flex-end"
              }}
            >
              <CloseIcon />
            </IconButton> */}
            <Stack
              direction="row"
              sx={{
                borderRadius: 2,
                backgroundColor: "white",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography color="text.default" variant="h3">
                Parolamı Değiştir
              </Typography>

            </Stack>

            <Typography
              color="text.default"
              variant="body1"
              flex={1}
              sx={{ mt: 2 }}
            >
              Parolanızı değiştirmeniz gerekmektedir. Lütfen aşağıdaki bilgileri
              doldurunuz.
            </Typography>
            <Typography
              color="text.default"
              variant="body1"
              flex={1}
              sx={{ mt: 2 }}
            >
              <ul>
                <li style={{ ...listItemStyle, color: hasMinLength ? 'green' : passwordValue ? 'red' : 'initial' }}>
                  Şifreniz en az {minLength} hane uzunluğunda,
                </li>
                <li style={{ ...listItemStyle, color: hasUpperCase ? 'green' : passwordValue ? 'red' : 'initial' }}>
                  En az 1 büyük harf
                </li>
                <li style={{ ...listItemStyle, color: hasLowerCase ? 'green' : passwordValue ? 'red' : 'initial' }}>
                  En az 1 küçük harf
                </li>
                <li style={{ ...listItemStyle, color: hasNumber ? 'green' : passwordValue ? 'red' : 'initial' }}>
                  En az 1 sayı
                </li>
                <li style={{ ...listItemStyle, color: hasSpecialCharacter ? 'green' : passwordValue ? 'red' : 'initial' }}>
                  En az 1 özel karakter içermelidir.
                </li>
              </ul>

            </Typography>
            <Box flex={1} sx={{ mt: 2 }}>
              <PasswordControl
                sx={{ width: "100%" }}
                defaultValue=""
                id="oldPassword"
                control={control}
                type="password"
                label="Şu Anki Şifre"
              />
            </Box>
            <Box flex={1} sx={{ mt: 2 }}>
              <PasswordControl
                sx={{ width: "100%" }}
                defaultValue=""
                id="password"
                control={control}
                type="password"
                label="Yeni Şifre"
                maxLength={maxLength}
              />
            </Box>
            <Box flex={1} sx={{ mt: 2 }}>
              <PasswordControl
                sx={{ width: "100%" }}
                defaultValue=""
                id="confirmPassword"
                control={control}
                type="password"
                label="Yeni Şifre (Tekrar)"
                maxLength={maxLength}
              />
            </Box>
            <Stack sx={{ mt: { xs: 1, sm: 5, md: 5, lg: 5, xl: 5 } }} justifyContent="center" alignItems="center">
              <Button
                onClick={checkPasswordAndSubmit}
                sx={{ width: 240, mb: 3 }}
                size="medium"
                variant="contained"
                text="Onayla"
              />
            </Stack>
          </Stack>
        </Stack>
      </Modal>
    </>
  );
};
